/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

const styles = StyleSheet.create({
  label: {
    display: 'block',
    marginBottom: 4,
  },
  labelWrapper: {
    marginBottom: 14,
  },
});

export interface LabelProps extends Omit<BlendBridge.API.LabelTaskDescription, 'type'> {}

export const Label: React.FC<LabelProps> = ({ label, value, ...htmlProps }: LabelProps) => {
  return (
    <div className={css(styles.labelWrapper)} {...htmlProps}>
      <label className={css(styles.label)}>
        <Text colorName="NIGHT_90" fontSize="sm">
          {label}
        </Text>
      </label>
      <Text className={css(styles.label)} colorName="NIGHT_80" fontSize="md" id={label} weight="medium">
        {value}
      </Text>
    </div>
  );
};
